import * as React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {
  Typography,
  Box,
  Container,
  TextField,
  CssBaseline,
  Avatar,
  Select,
  MenuItem,
  IconButton,
  CircularProgress,
  Paper,
  FormControl,
  Tabs,
  Tab
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { connect } from "react-redux";
import { loginIMSAdmin, signUp } from "../../app/store/actions/authActions";
import {
  Navigate,
  NavLink,
  Route,
  Routes,
  useNavigate,
  useParams
} from "react-router-dom";
import {
  centered_flex_box,
  MainInput,
  MainInputLabel,
  MainPassword,
  main_button,
  StyledInput,
  MainPhone,
  sec_button
} from "../../app/components/Styles";
import { isMobile } from "react-device-detect";
import { Image, Space, Table, Button } from "antd";
import {
  antTableWrapperSx,
  tableShowTotal,
  idTableColumn,
} from "../../app/components/AntTableStyles";
import Logo from "../../app/components/logo.png";
import PropTypes from "prop-types";
import MuiPhoneNumber from "material-ui-phone-number";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import ImageComponent from "../../app/components/ImageComponent";
import { getShippingServices, deleteShippingServices } from "../../app/store/actions/imsAdminActions";
import { useEffect } from "react";
import { AddCircleOutline } from "@mui/icons-material";
import EditBrandModal from "../../app/components/EditBrandModal";
import ActionDialog from "../../app/components/ActionDialog";

export const ShippingServicesList = ({
  getShippingServices,
  deleteShippingServices,
  user,
  shippingServices,
  isLoading,
}) => {
  const navigate = useNavigate();
  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
  const [serviceToDelete, setServiceToDelete] = React.useState(null);
  const [visibleKeys, setVisibleKeys] = React.useState(new Map());
  const currentLocale = Cookies.get("i18next") || "en";
  const { t, i18n } = useTranslation();

  useEffect(() => {
    getShippingServices({ page: 1, limit: 10000 })
  }, [])

  const handleDeleteClick = (record) => {
    setServiceToDelete(record);
    setOpenDeleteDialog(true);
  };

  const handleDeleteConfirm = () => {
    if (serviceToDelete) {
      deleteShippingServices({ shippingServiceId: serviceToDelete._id });
      setOpenDeleteDialog(false);
      setServiceToDelete(null);
    }
  };

  const handleDeleteCancel = () => {
    setOpenDeleteDialog(false);
    setServiceToDelete(null);
  };

  const toggleKeyVisibility = (id) => {
    setVisibleKeys(prev => {
      const newMap = new Map(prev);
      newMap.set(id, !newMap.get(id));
      return newMap;
    });
  };

  const columns = [
    idTableColumn(),
    {
      title: 'Shipping Service',
      dataIndex: 'service',
    },
    {
      title: 'Service Name',
      dataIndex: 'name',
    },
    {
      title: 'Service API Key',
      dataIndex: 'key',
      render: (text, record) => {
        const isVisible = visibleKeys.get(record._id) || false;
        return (
          <Space>
            {isVisible ? text : '••••••••••••'}
            <Button size="small" onClick={() => toggleKeyVisibility(record._id)}>
              {isVisible ? 'Hide' : 'Show'}
            </Button>
          </Space>
        );
      }
    },
    {
      title: 'Actions',
      render: (_, record) => <Space>
        <Button danger onClick={() => handleDeleteClick(record)}>Delete</Button>
      </Space>
    },
  ];

  const data = shippingServices?.docs?.map((row) => {
    return {
      _id: row._id,
      name: row.name,
      service: row.service,
      key: row.key,
    }
  })

  return (
    <div>
      <Box sx={{ width: "100%", px: 5 }}>
        <Box sx={{ ...centered_flex_box, mb: 1 }}>
          <Typography variant='h4' sx={{ color: "var(--secColor)" }}>Shipping Services</Typography>
          <IconButton onClick={() => navigate("/ims/admin/shipping-services/create")} sx={{ color: "var(--secColor)", mx: 2 }}><AddCircleOutline /></IconButton>
        </Box>
        <Box sx={antTableWrapperSx(isMobile, 800)}>
          <Table
            columns={columns}
            dataSource={data}
            loading={isLoading}
            showSorterTooltip={{
              target: 'sorter-icon',
            }}
            pagination={{
              pageSize: 10,
              showSizeChanger: true,
              showQuickJumper: false,
              showTotal: tableShowTotal("services"),
              total: data?.length || 0,
            }}
            scroll={{ x: isMobile ? 300 : 800 }}
          />
        </Box>
        <ActionDialog
          open={openDeleteDialog}
          handleClose={handleDeleteCancel}
          handleAccept={handleDeleteConfirm}
          title="Confirm Deletion"
          content={`Are you sure you want to delete the shipping service "${serviceToDelete?.service} (${serviceToDelete?.name})"? This action cannot be undone.`}
        />
      </Box>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state?.auth?.user,
  isLoading: state?.records?.isLoading || state?.wait?.isLoading,
  token: state?.auth?.token,
  shippingServices: state?.records?.shippingServices
});

const mapDispatchToProps = { getShippingServices, deleteShippingServices };

export default connect(mapStateToProps, mapDispatchToProps)(ShippingServicesList);
